import React from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import Landing from './components/Landing';
import Formulario from './components/Formulario';
import Terminos from './components/Terminos';
import './App.css';

function AppContent() {
  const navigate = useNavigate();

  const handleShowTerminos = () => navigate('/terminos');
  const handleBack = () => navigate(-1);

  return (
    <div className="App">
      <div className="desktop-message">
        <div className="desktop-message-content">
          <h1>Solo disponible para móviles</h1>
          <p>Esta aplicación está diseñada para ser utilizada en dispositivos móviles.</p>
          <p>Por favor, accedé desde tu teléfono o tablet.</p>
        </div>
      </div>

      <div className="mobile-content">
        <Routes>
          <Route path="/terminos" element={<Terminos onBack={handleBack} />} />
          <Route path="/form" element={<Formulario />} />
          <Route path="/:cadena" element={<Landing onShowTerminos={handleShowTerminos} />} />
          <Route path="/" element={<Landing onShowTerminos={handleShowTerminos} />} />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
